import { api } from "./api";

export const fetchHealth = () => api.get("/health").then((r) => r.data);
